module.exports = __webpack_public_path__ + "static/media/Padaloma.e446bf7c.ttf";